import React from 'react';
import { useTranslation } from 'react-i18next';
import { MaintenanceViewProps } from 'pages/CatalogPage/DH/Maintenance/Maintenance';
import MaintenancePdf from 'pages/CatalogPage/DH/Maintenance/MaintenancePdf';
import { useGetMaintenanceDocumentation } from 'pages/CatalogPage/DH/MaintenanceValues/MaintenanceValues';
import { Box, Flex, MarginBox, Pipeline, Text } from 'UI';

const MaintenanceHeader = ({ maintenancePlanData, getLabel, units, val }: MaintenanceViewProps) => {
  const { t } = useTranslation();
  const menu = useGetMaintenanceDocumentation();

  return (
    <MarginBox my={30}>
      <Flex>
        <Text type={'h1_banner_light'} disableGutter>
          {t('catalog.parts.category.maintenance_plan', 'Maintenance plan')}
        </Text>
        <Flex direction={'row-reverse'} align={'center'}>
          <MaintenancePdf maintenancePlanData={maintenancePlanData} getLabel={getLabel} units={units} val={val} />
          <MarginBox mr={20} />
          {menu}
        </Flex>
      </Flex>
      <Box height={30} />
      <Pipeline horizontal size={'100%'} />
    </MarginBox>
  );
};
export default MaintenanceHeader;
